import request from '@/utils/request'
export function getTaskList(data) {
  return request({
    url: '/api/execute/fileTaskService/queryPage',
    method: 'post',
    data
  })
}

export function getFilePath(data) {
  return request({
    url: '/api/execute/FileTaskService/getHttpUrl',
    method: 'post',
    data
  })
}

export function getFileStatus(data) {
  return request({
    url: '/api/execute/FileTaskService/getStatus',
    method: 'post',
    data
  })
}

export function getI18nMessage(lang) {
  // 将语言代码转换为接口需要的格式
  const langMap = {
    'zh': 'zh_CN',
    'en': 'en_US',
    'fr': 'fr_FR'
  }
  return request({
    url: '/api/execute/i18nResourceRpcService/listI18nResource',
    method: 'post',
    data: {
      portal: window?.SITE_CONFIG?.portal,
      languageCode: langMap[lang] || 'en_US'
    }
  })
}
